import { render } from "./EventosMatapa.vue?vue&type=template&id=57065e2b"
import script from "./EventosMatapa.vue?vue&type=script&lang=js"
export * from "./EventosMatapa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__